
import { Shield, Eye, Activity, AlertTriangle, BarChart3, Bell } from "lucide-react";
import { LandingPageTemplate } from "@/components/layout/LandingPageTemplate";
import { HeroSection } from "@/components/landing/HeroSection";
import { FeatureSection } from "@/components/landing/FeatureSection";
import { ProcessSection } from "@/components/landing/ProcessSection";
import { BenefitSection } from "@/components/landing/BenefitSection";
import { CtaSection } from "@/components/landing/CtaSection";

const ManagedSiem = () => {
  return (
    <LandingPageTemplate
      title="Managed SIEM Services"
      description="24/7 managed Security Information and Event Management (SIEM) services for comprehensive threat detection and response."
      keywords={[
        "managed SIEM",
        "security monitoring",
        "threat detection",
        "log management",
        "security analytics"
      ]}
      canonicalUrl="/cybersecurity/managed-siem/"
      schemaType="service"
      schemaData={{
        name: "Managed SIEM Services",
        description: "Expert SIEM management and security monitoring",
        provider: {
          name: "edgefi",
          sameAs: "https://edgefi.com"
        }
      }}
    >
      <HeroSection
        title="24/7 Security"
        highlighted="Monitoring"
        description="Comprehensive managed SIEM services for real-time threat detection, analysis, and response across your infrastructure."
        ctaText="Get Protected"
        heroPattern="grid"
      />

      <FeatureSection 
        title="Managed SIEM Features"
        subtitle="KEY CAPABILITIES"
        description="Our managed SIEM services provide comprehensive security monitoring and analysis."
        features={[
          {
            title: "24/7 Monitoring",
            description: "Round-the-clock security monitoring.",
            icon: <Eye className="h-6 w-6 text-purple-600" />
          },
          {
            title: "Threat Detection",
            description: "Advanced threat detection and analysis.",
            icon: <Shield className="h-6 w-6 text-purple-600" />
          },
          {
            title: "Log Management",
            description: "Centralized log collection and analysis.",
            icon: <Activity className="h-6 w-6 text-purple-600" />
          },
          {
            title: "Alert Triage",
            description: "Expert alert investigation and prioritization.",
            icon: <AlertTriangle className="h-6 w-6 text-purple-600" />
          },
          {
            title: "Reporting",
            description: "Comprehensive security reporting.",
            icon: <BarChart3 className="h-6 w-6 text-purple-600" />
          },
          {
            title: "Incident Response",
            description: "Rapid incident response coordination.",
            icon: <Bell className="h-6 w-6 text-purple-600" />
          }
        ]}
      />

      <ProcessSection
        title="Our SIEM Approach"
        subtitle="METHODOLOGY"
        description="A comprehensive approach to SIEM management"
        steps={[
          {
            title: "Setup",
            description: "Initial SIEM configuration and tuning"
          },
          {
            title: "Integration",
            description: "Connect security data sources"
          },
          {
            title: "Monitoring",
            description: "Continuous security monitoring"
          },
          {
            title: "Analysis",
            description: "Expert threat analysis"
          },
          {
            title: "Response",
            description: "Incident response coordination"
          }
        ]}
      />

      <BenefitSection
        title="Why Choose Our Managed SIEM"
        benefits={[
          {
            title: "Expert Team",
            description: "Certified security analysts"
          },
          {
            title: "24/7 Coverage",
            description: "Round-the-clock monitoring"
          },
          {
            title: "Cost Effective",
            description: "Reduced operational costs"
          },
          {
            title: "Quick Response",
            description: "Rapid threat detection"
          },
          {
            title: "Compliance",
            description: "Meet regulatory requirements"
          },
          {
            title: "Scalability",
            description: "Grows with your needs"
          }
        ]}
      />

      <CtaSection 
        title="Ready for Advanced Security Monitoring?"
        description="Get started with our managed SIEM services today."
        ctaText="Schedule Consultation"
        background="purple"
        modalTitle="Request Managed SIEM"
        modalDescription="Tell us about your security monitoring needs."
        additionalFields={{
          lead_source: "Website",
          lead_interest: "Managed SIEM",
          service_interest: "Security Monitoring"
        }}
      />
    </LandingPageTemplate>
  );
};

export default ManagedSiem;
